// Season touches: a small colour on the header for Saudi National Day, Founding Day and Ramadan evenings.
// Worked out from the date in Riyadh (Ramadan from the Umm al-Qura calendar); each person can turn them off.

export type Season = 'national' | 'founding' | 'ramadan' | null;

export function currentSeason(now = new Date()): Season {
  const md = now.toLocaleDateString('en-CA', { timeZone: 'Asia/Riyadh' }).slice(5);
  if (md >= '09-22' && md <= '09-24') return 'national';
  if (md >= '02-21' && md <= '02-23') return 'founding';
  try {
    const hijri = new Intl.DateTimeFormat('en-u-ca-islamic-umalqura', { month: 'numeric', timeZone: 'Asia/Riyadh' });
    // A browser without the Umm al-Qura calendar falls back to the normal one (9 would be September): no Ramadan touch then.
    if (hijri.resolvedOptions().calendar !== 'islamic-umalqura') return null;
    const month = Number(hijri.format(now).replace(/\D/g, ''));
    const hour = Number(now.toLocaleTimeString('en-GB', { hour: '2-digit', hour12: false, timeZone: 'Asia/Riyadh' }).slice(0, 2));
    // Ramadan, after Maghrib (about 6 pm) until the early morning.
    if (month === 9 && (hour >= 18 || hour < 4)) return 'ramadan';
  } catch { /* no Hijri calendar in this browser: no Ramadan touch */ }
  return null;
}

export const SEASON_LABEL: Record<Exclude<Season, null>, string> = {
  national: 'Saudi National Day', founding: 'Founding Day', ramadan: 'Ramadan Kareem',
};
